// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fad80128","879":"631f042c"}[chunkId] + ".chunk.js";
};